<!-- <pre>{{ brokenevents | async | json }}</pre> -->

<h1 [ngStyle]="{'margin':'50px 0 50px 120px'}">Broken Events</h1>

<div *ngIf="brokenevents | async as events">
    <div *ngFor="let event of events; let i = index" [ngStyle]="{'font-size':'0.8em','margin':'10px'}">
        {{ i+1 }} - {{ event.date | date }} - {{ event.title }}
    </div>
</div>